import { useTreeStore } from '@/stores/treeStore';

/**
 * Hook for node-specific state and actions
 * @param nodeId - The node ID to get state for
 * @returns Object with node state and expansion actions
 */
export function useNodeState(nodeId: string | undefined) {
  const node = useTreeStore((state) => (nodeId ? state.nodes.get(nodeId) : null));
  const isExpanded = useTreeStore((state) => (nodeId ? state.expandedNodes.has(nodeId) : false));
  const isLoaded = useTreeStore((state) => (nodeId ? state.loadedNodes.has(nodeId) : false));

  const expandNode = useTreeStore((state) => state.expandNode);
  const collapseNode = useTreeStore((state) => state.collapseNode);

  return {
    node,
    isExpanded,
    isLoaded,
    expand: nodeId ? () => expandNode(nodeId) : () => {},
    collapse: nodeId ? () => collapseNode(nodeId) : () => {},
    toggle: nodeId ? () => (isExpanded ? collapseNode(nodeId) : expandNode(nodeId)) : () => {},
  };
}

/**
 * Hook for tree selection state and actions
 * @returns Object with selected node and selection actions
 */
export function useTreeSelection() {
  const selectedNode = useTreeStore((state) => state.selectedNode);
  const setSelectedNode = useTreeStore((state) => state.setSelectedNode);

  return {
    selectedNode,
    selectNode: setSelectedNode,
    clearSelection: () => setSelectedNode(null),
  };
}
